import React, { useState } from 'react';

const GalleryPage = () => {
  const images = [
    { thumb: 'images/babbb.png', full: 'images/rezba-01.jpg', title: 'Dubová socha patrona' },
    { thumb: 'images/baba.png', full: 'images/rezba-02.jpg', title: 'Reliéf – lesní motiv' },
    { thumb: 'images/babb.png', full: 'images/rezba-03.jpg', title: 'Plastika z tisu' },
    // Tady si dopiš klidně 20 dalších fotek...
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  return (
    <div style={{ backgroundColor: '#fef3dc', minHeight: '100vh', paddingTop: '120px' }}>
      <div style={{ maxWidth: '1200px', margin: 'auto', padding: '0 20px' }}>
        <h1 style={{ fontSize: '3.5rem', textAlign: 'center', marginBottom: '20px' }}>Kompletní portfolio</h1>
        <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '50px' }}>
          Každý detail začíná s dřevem a končí s duší.
        </p>

        {/* Mřížka galerie */}
        <section className="carving-gallery">
          <div className="grid">
            {images.map((img, index) => (
              <div key={index} className="tile" onClick={() => openLightbox(index)} style={{ cursor: 'pointer' }}>
                <img src={img.thumb} alt={img.title} />
                <span className="caption">{img.title}</span>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Lightbox */}
      {isOpen && (
        <div className="lightbox" style={{ display: 'flex' }} onClick={() => setIsOpen(false)}>
          <button className="lb-btn lb-close">✕</button>
          <button className="lb-btn lb-prev" onClick={(e) => {
            e.stopPropagation();
            setCurrentIndex((currentIndex - 1 + images.length) % images.length);
          }}>‹</button>
          
          <img className="lb-img" src={images[currentIndex].full} alt={images[currentIndex].title} />
          
          <button className="lb-btn lb-next" onClick={(e) => {
            e.stopPropagation();
            setCurrentIndex((currentIndex + 1) % images.length);
          }}>›</button>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;